import { createSlice } from "infrastructure/store/lib";
import { sliceMixin } from "infrastructure/store/reducers";
import { MenuItem } from "consts/waMessaging";
import type { WaMessagingState } from "./types";
import initialState, { sliceToken } from "./state";
import {
    getWaMessagesThunk,
    getWaMessagesSetupsThunk,
    createWaMessagesSetupThunk,
    updateWaMessagesSetupThunk,
    getPhoneVerificationsThunk,
    getFailedPhoneVerificationsThunk,
    getWaTemplatesSetupsThunk,
    createWaTemplatesSetupThunk,
    updateWaTemplatesSetupThunk
} from "./thunks";
import {
    waMessagingResourceRequestLoading,
    waMessagingResourceRequestRejected,
    exportWaMessagingResourceLoading,
    waMessagesRequestFulfilled,
    waMessagesSetupsRequestFulfilled,
    createWaMessagesSetupFulfilled,
    updateWaMessagesSetupFulfilled,
    phoneVerificationsRequestFulfilled,
    failedPhoneVerificationsRequestFulfilled,
    waTemplatesSetupsRequestFulfilled,
    createWaTemplatesSetupFulfilled,
    updateWaTemplatesSetupFulfilled
} from "./reducers";

const slice = createSlice({
    name: sliceToken,
    initialState,
    reducers: {
        ...sliceMixin<WaMessagingState>(initialState),
        changeExportWaMessagesLoading: exportWaMessagingResourceLoading(MenuItem.WaMessages),
        changeExportWaMessagesSetupsLoading: exportWaMessagingResourceLoading(MenuItem.WaMessagesSetups),
        changeExportPhoneVerificationsLoading: exportWaMessagingResourceLoading(MenuItem.PhoneVerifications),
        changeExportFailedPhoneVerificationsLoading: exportWaMessagingResourceLoading(MenuItem.FailedPhoneVerifications),
        changeExportWaTemplatesSetupsLoading: exportWaMessagingResourceLoading(MenuItem.WaTemplatesSetups)
    },
    extraReducers: builder => {
        builder
            .addCase(getWaMessagesThunk.pending, waMessagingResourceRequestLoading(MenuItem.WaMessages))
            .addCase(getWaMessagesThunk.fulfilled, waMessagesRequestFulfilled)
            .addCase(getWaMessagesThunk.rejected, waMessagingResourceRequestRejected(MenuItem.WaMessages))
            .addCase(getWaMessagesSetupsThunk.pending, waMessagingResourceRequestLoading(MenuItem.WaMessagesSetups))
            .addCase(getWaMessagesSetupsThunk.fulfilled, waMessagesSetupsRequestFulfilled)
            .addCase(getWaMessagesSetupsThunk.rejected, waMessagingResourceRequestRejected(MenuItem.WaMessagesSetups))
            .addCase(createWaMessagesSetupThunk.pending, waMessagingResourceRequestLoading(MenuItem.WaMessagesSetups))
            .addCase(createWaMessagesSetupThunk.fulfilled, createWaMessagesSetupFulfilled)
            .addCase(createWaMessagesSetupThunk.rejected, waMessagingResourceRequestRejected(MenuItem.WaMessagesSetups))
            .addCase(updateWaMessagesSetupThunk.pending, waMessagingResourceRequestLoading(MenuItem.WaMessagesSetups))
            .addCase(updateWaMessagesSetupThunk.fulfilled, updateWaMessagesSetupFulfilled)
            .addCase(updateWaMessagesSetupThunk.rejected, waMessagingResourceRequestRejected(MenuItem.WaMessagesSetups))
            .addCase(getPhoneVerificationsThunk.pending, waMessagingResourceRequestLoading(MenuItem.PhoneVerifications))
            .addCase(getPhoneVerificationsThunk.fulfilled, phoneVerificationsRequestFulfilled)
            .addCase(getPhoneVerificationsThunk.rejected, waMessagingResourceRequestRejected(MenuItem.PhoneVerifications))
            .addCase(getFailedPhoneVerificationsThunk.pending, waMessagingResourceRequestLoading(MenuItem.FailedPhoneVerifications))
            .addCase(getFailedPhoneVerificationsThunk.fulfilled, failedPhoneVerificationsRequestFulfilled)
            .addCase(getFailedPhoneVerificationsThunk.rejected, waMessagingResourceRequestRejected(MenuItem.FailedPhoneVerifications))
            .addCase(getWaTemplatesSetupsThunk.pending, waMessagingResourceRequestLoading(MenuItem.WaTemplatesSetups))
            .addCase(getWaTemplatesSetupsThunk.fulfilled, waTemplatesSetupsRequestFulfilled)
            .addCase(getWaTemplatesSetupsThunk.rejected, waMessagingResourceRequestRejected(MenuItem.WaTemplatesSetups))
            .addCase(createWaTemplatesSetupThunk.pending, waMessagingResourceRequestLoading(MenuItem.WaTemplatesSetups))
            .addCase(createWaTemplatesSetupThunk.fulfilled, createWaTemplatesSetupFulfilled)
            .addCase(createWaTemplatesSetupThunk.rejected, waMessagingResourceRequestRejected(MenuItem.WaTemplatesSetups))
            .addCase(updateWaTemplatesSetupThunk.pending, waMessagingResourceRequestLoading(MenuItem.WaTemplatesSetups))
            .addCase(updateWaTemplatesSetupThunk.fulfilled, updateWaTemplatesSetupFulfilled)
            .addCase(updateWaTemplatesSetupThunk.rejected, waMessagingResourceRequestRejected(MenuItem.WaTemplatesSetups));
    }
});

export const {
    name,
    actions: {
        changeExportWaMessagesLoading,
        changeExportWaMessagesSetupsLoading,
        changeExportPhoneVerificationsLoading,
        changeExportFailedPhoneVerificationsLoading,
        changeExportWaTemplatesSetupsLoading
    }
} = slice;

export default slice.reducer;
